module.exports = __webpack_public_path__ + "img/1.b16d43b6.jpg";